import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3f2eb587"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "contact" }
const _hoisted_3 = { class: "myName" }
const _hoisted_4 = { style: {"color":"#444"} }
const _hoisted_5 = { style: {"color":"#444"} }
const _hoisted_6 = { style: {"background-color":"#219ebc","padding-top":"0.2vw","padding-bottom":"2vw"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-top":"5vw","font-weight":"1000","font-size":"35px"} }, " Experience ", -1))
const _hoisted_8 = { style: {"color":"white"} }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  key: 0,
  style: {"margin-left":"5vw","color":"#8ecae6"}
}
const _hoisted_11 = { style: {"margin-left":"7vw"} }
const _hoisted_12 = { style: {"margin-left":"7vw"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border-color":"#8ecae6"} }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { style: {"background-color":"#219ebc","padding-top":"0.5vw"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-top":"1vw","font-weight":"1000","font-size":"35px"} }, " Education ", -1))
const _hoisted_18 = { style: {"color":"white"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border-color":"#219ebc"} }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import res from "../data/text.json";
import SummaryOfSkills from "@/components/SummaryOfSkills.vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "ResumeView",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const resume = res;

return (_ctx: any,_cache: any) => {
  const _directive_motion_slide_visible_once_right = _resolveDirective("motion-slide-visible-once-right")!
  const _directive_motion_slide_visible_once_left = _resolveDirective("motion-slide-visible-once-left")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("h1", null, [
      _createTextVNode("Résumé")
    ])), [
      [_directive_motion_slide_visible_once_right]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(resume).name), 1),
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(resume).location), 1),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(resume).email), 1)
    ])), [
      [_directive_motion_slide_visible_once_left]
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(SummaryOfSkills)
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resume).experience, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.company,
          class: "education-block"
        }, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(item.company), 1),
          _createElementVNode("h3", null, _toDisplayString(item.location), 1),
          _createElementVNode("h3", null, _toDisplayString(item.position), 1),
          _createElementVNode("h3", null, _toDisplayString(item.duration), 1),
          _createElementVNode("h3", _hoisted_9, _toDisplayString(item.description), 1),
          (item.publications.length > 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_10, " Notable Publications "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.publications, (sub) => {
            return (_openBlock(), _createElementBlock("div", {
              key: sub.name,
              class: "publications"
            }, [
              _createElementVNode("h4", null, "[" + _toDisplayString(sub.name) + "]", 1),
              _createElementVNode("h4", _hoisted_11, "- " + _toDisplayString(sub.description), 1),
              _createElementVNode("h4", _hoisted_12, "- " + _toDisplayString(sub.details), 1),
              _hoisted_13
            ]))
          }), 128)),
          _hoisted_14,
          _hoisted_15
        ]))
      }), 128))
    ])), [
      [_directive_motion_slide_visible_once_left]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
      _hoisted_17,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resume).education, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.school,
          class: "education-block"
        }, [
          _createElementVNode("h3", _hoisted_18, _toDisplayString(item.school), 1),
          _createElementVNode("h3", null, _toDisplayString(item.studies), 1),
          _createElementVNode("h3", null, _toDisplayString(item.years), 1),
          _createElementVNode("h3", null, _toDisplayString(item.honors), 1),
          _createElementVNode("h3", null, _toDisplayString(item.description), 1),
          _hoisted_19,
          _hoisted_20
        ]))
      }), 128))
    ])), [
      [_directive_motion_slide_visible_once_left]
    ])
  ]))
}
}

})